import { useEffect, useState } from "react";
// REDUX
import { useGetActionsQuery } from "../../redux/actions/actionsAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { ActionInterface } from "../../interfaces/Actions.interface";

export default function useGetAllActions({ page = 1, limit = 999999 }: { page?: number; limit?: number } = {}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [actions, setActions] = useState<ActionInterface[]>([]);
	const [token, setToken] = useState<string | null>(null);
	const [errorObject, setErrorObject] = useState<any>({});
	const [errorMessage, setErrorMessage] = useState<string>("Error");
	const [totalRows, setTotalRows] = useState<number>(0);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isError, isFetching, error } = useGetActionsQuery(
		{ token, page, limit },
		{ skip: !token, refetchOnMountOrArgChange: false } // if token exists, launch
	);

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setActions(data.data);
			setTotalRows(data.total || 0);
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			setErrorObject(error);
		}
	}, [error]);

	useEffect(() => {
		if (errorObject && errorObject.data && errorObject.data.message) {
			setErrorMessage(errorObject.data.message);
		}
	}, [errorObject]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		actions,
		isLoadingGetAllActions: isLoading || isFetching,
		errorMessageGetAllActions: errorMessage,
		isErrorGetAllActions: isError,
		totalRowsGetAllActions: totalRows,
	};
}
